import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID } from 'utils/types';
import argTypes from 'utils/arg-types';
import { sortBy } from 'lodash';
import request from 'utils/request';
import reportError from 'utils/report-error';
import { Dropdown } from 'semantic-ui-react';
import './ConnectionDropdown.scss';

const rawConnectionType = argTypes('rawConnection', PropTypes.arrayOf(PropTypes.shape({
  id: SFEntityID.isRequired,
  type: PropTypes.string.isRequired,
  sectionId: PropTypes.string,
  name: PropTypes.string.isRequired,
})).isRequired);

const toConnectionViewModel = rawConnectionType(rawConnections => {

  let connections = rawConnections.map(connection => {
    connection.sortIndex = (connection.type === 'role' ? 1 : 3) + connection.name.toLowerCase();
    return connection;
  });

  connections.unshift({
    id: -1,
    name: 'All My Students',
    sortIndex: '00'
  });

  return sortBy(connections, "sortIndex");
});

const fetchConnections = () => {
  return request.fetchAuthenticatedStarfishJSON('../instructor/getStudentListConnections.html', 'results', {
    method: 'POST',
    body: request.urlParams({
      term: -1,
      intakeOnly: true
    })
  }).then(toConnectionViewModel);
};

export class ConnectionDropdown extends React.Component {

  constructor() {
    super();
    this.state = { connections: [] };
  }

  renderConnectionDropdownOptionContent = (name, sectionId) => {
    return !sectionId
      ? <div><b>{name}</b></div>
      : (
      <div>
        <b>{name}</b>
        <br/>
        {sectionId}
      </div>
      );
  }

  toConnectionDropdownOption = (connection) => {
    return {
      text: connection.name,
      content: this.renderConnectionDropdownOptionContent(connection.name, connection.sectionId),
      value: connection.id
    };
  }


  componentDidMount() {
    fetchConnections()
      .then((connections) => this.setState({ connections }))
      .catch(reportError);
  }

  render() {
    return (
      <Dropdown 
        selection
        id={this.props.id}
        options={this.state.connections.map(this.toConnectionDropdownOption)}
        defaultValue={this.props.defaultConnection}                
        onChange={(e, selectedConnection) => this.props.onChange(selectedConnection.value)} 
      />
    );
  }
}

ConnectionDropdown.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  defaultConnection: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
